export function copyNonInput(value, asyncCopy) {
  const body = document.getElementsByTagName("body")[0]

  const storage = document.createElement("input")
  storage.value = value

  body.appendChild(storage)

  storage.select()
  storage.setSelectionRange(0, 99999);
  document.execCommand("copy")
  body.removeChild(storage);
  asyncCopy(true)
  setTimeout(() => asyncCopy(false), 2000)
}
export function copyInput(el, asyncCopy) {
  el.select()
  el.setSelectionRange(0, 99999);
  document.execCommand("copy")
  asyncCopy(true)
  setTimeout(() => asyncCopy(false), 2000)
}